import { Spin } from 'antd'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import Amount from '../Amount'
import { useCurrentInvoice } from './queries'

const TaxRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

const TaxBlock = () => {
  const invoiceQuery = useCurrentInvoice()
  const tax = invoiceQuery.data?.tax

  return (
    <Spin
      spinning={invoiceQuery.isLoading}
      style={{ width: '100%', whiteSpace: 'nowrap' }}
    >
      {!!tax ? (
        <TaxRow>
          <div>{tax.name}</div>
          <div>
            ({Math.round((100 * tax.rate.numerator) / tax.rate.denominator)} %)
          </div>
          <Amount unit={invoiceQuery.data?.unitID ?? ''} amount={tax.amount} />
        </TaxRow>
      ) : (
        <FormattedMessage id="notApplicable" />
      )}
    </Spin>
  )
}

export default TaxBlock
